module.exports = __webpack_public_path__ + "static/media/icon-geographic.ff1ea4d1.svg";